import ProductCard from '@/components/ProductCard';
import { SliderArrow } from '@/components/SliderArrow';
import { Default_Image } from '@/constants';
import { useElementOnScreen } from '@/hooks/intersectionObserver';
import { IconArrowLeftDouble } from '@/icons/IconArrowLeftDouble';
import { IconArrowRightDouble } from '@/icons/IconArrowRightDouble';
import { IProductSlide } from '@/interfaces/product';
import { useEffect, useState } from 'react';
import { Autoplay, Navigation } from 'swiper';
import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { AutoplayOptions } from 'swiper/types';

const ProductSlider = ({
  title = '',
  products,
  className = '',
  isCategoryProduct,
  // slideClassName = 'sm:pr-1',
  slideClassName = '',
  config = { slidesPerView: 'auto', spaceBetween: 14 },
  showArrow,
  autoplay = false,
  isHomePage,
  navigation,
  sliderType,
  autoPlayTimer,
  setSwiper = (s: any) => {},
}: {
  title?: string;
  products: IProductSlide[];
  className?: string;
  slideClassName?: string;
  config?: any;
  isCategoryProduct?: boolean;
  showArrow?: boolean;
  autoplay?: boolean | AutoplayOptions;
  isHomePage?: boolean;
  navigation?: boolean;
  sliderType?: string;
  autoPlayTimer?: number;
  setSwiper?: (s: any) => void;
}) => {
  const [isMounted, setIsMounted] = useState<boolean>(false);

  const { containerRef, isVisible } = useElementOnScreen({
    root: null,
    rootMargin: '-100px',
    threshold: 0.0,
  });

  useEffect(() => {
    if (isVisible && isHomePage) {
      containerRef?.current?.swiper?.autoplay.start();
    } else {
      containerRef?.current?.swiper?.autoplay.stop();
    }
    if (isVisible) {
      setIsMounted(true);
    }
  }, [isVisible]);

  const swiperInternalComponent = (products?: IProductSlide[]) => {
    return (
      <Swiper
        {...config}
        key={isMounted.toString()}
        ref={containerRef}
        autoplay={autoPlayTimer ? autoPlayTimer - 1000 : false}
        modules={[Navigation, Autoplay]}
        className="content-slider "
        wrapperClass="flex"
        loop
        onSwiper={(s) => {
          setSwiper && typeof setSwiper === 'function' && setSwiper(s);
        }}
        slidesPerView={1}
        breakpoints={{
          400: {
            slidesPerView: 2,
            autoplay: {
              delay: autoPlayTimer,
            },
          },

          640: {
            slidesPerView: 3,
            autoplay: {
              delay: autoPlayTimer,
            },
          },

          1024: {
            slidesPerView: 4,
            autoplay: {
              delay: autoPlayTimer,
            },
          },

          1400: {
            slidesPerView: 5,
            autoplay: {
              delay: autoPlayTimer,
            },
          },
          1700: {
            slidesPerView: 6,
            autoplay: {
              delay: autoPlayTimer,
            },
          },
        }}
        navigation={{
          prevEl: `.${sliderType}-swipe-prev`,
          nextEl: `.${sliderType}-swipe-next`,
        }}
      >
        {products?.map((slide, index) => (
          <SwiperSlide key={slide.seName + index} style={{ width: 'fit-content' }}>
            <ProductCard
              key={slide.seName}
              className={slideClassName}
              name={slide?.name}
              url={`/product/${slide.seName}`}
              category={slide?.CategoryName}
              options={slide?.options}
              imageUrl={slide?.FeaturedImageUrl !== '' ? slide?.FeaturedImageUrl : Default_Image}
              imageAlt={`Slide ${index} ${slide?.altText ? slide?.altText : slide?.seName}`}
              oldPrice={slide?.productPrice?.OldPrice}
              price={slide?.productPrice?.Price}
              seName={slide?.seName}
              isCategoryProduct={isCategoryProduct}
              isCategoryVisible={false}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    );
  };

  return (
    <div className={`product-details-swiper ${className} relative w-[100%] ${navigation ? 'px-10 lg:px-12' : ''}  `}>
      {title && <h4 className="mb-5 font-bold uppercase">{title}</h4>}
      {isMounted ? swiperInternalComponent(products) : swiperInternalComponent(products && products?.length > 6 ? products?.slice(0, 6) : products)}

      <div
        className={`${sliderType}-swipe-prev swipe-prev absolute top-0 left-0 bottom-0 right-0 max-2xs:aspect-square 2xs:h-[calc(50vw-15px-1rem)] sm:h-[calc(33.3333vw-14px-1rem)] md:hidden`}
      >
        <SliderArrow className="top-1/2 left-0 -translate-y-1/2 !p-1">
          <IconArrowLeftDouble className="h-8 w-8 text-white" />
        </SliderArrow>
      </div>
      <div
        className={`${sliderType}-swipe-next swipe-next absolute top-0 left-0 bottom-0 right-0 max-2xs:aspect-square 2xs:h-[calc(50vw-15px-1rem)] sm:h-[calc(33.3333vw-14px-1rem)] md:hidden`}
      >
        <SliderArrow className="top-1/2 right-0 -translate-y-1/2 !p-1">
          <IconArrowRightDouble className="h-8 w-8 text-white" />
        </SliderArrow>
      </div>
      {/* <div className="mt-16 md:hidden">
        <Link prefetch={false} href={'#'} className="underline-custom text-xl font-medium">
          View All
        </Link>
      </div> */}
    </div>
  );
};

export default ProductSlider;
